/**
 * Aspect ratios for images.
 * @typedef {Object} ImageAspectRatios
 * @property {string} RATIO_16_9 - Aspect ratio of 16:9.
 * @property {string} RATIO_1_1 - Aspect ratio of 1:1.
 * @property {string} RATIO_4_3 - Aspect ratio of 4:3.
 * @property {string} RATIO_3_2 - Aspect ratio of 3:2.
 * @property {string} RATIO_3_4 - Aspect ratio of 3:4.
 * @property {string} RATIO_AUTO - Aspect ratio of auto.
 */

/**
 * Image aspect ratios.
 * @type {ImageAspectRatios}
 */
export const IMAGE_ASPECT_RATIOS = {
  RATIO_16_9: "16/9",
  RATIO_1_1: "1/1",
  RATIO_4_3: "4/3",
  RATIO_3_2: "3/2",
  RATIO_3_4: "3/4",
  RATIO_AUTO: "auto"
};

/**
 * @typedef {Object} AspectRatioClasses
 * @property {string} aspect-1/1 - Class for aspect ratio 1:1.
 * @property {string} aspect-16/9 - Class for aspect ratio 16:9.
 * @property {string} aspect-4/3 - Class for aspect ratio 4:3.
 * @property {string} aspect-3/2 - Class for aspect ratio 3:2.
 * @property {string} aspect-3/4 - Class for aspect ratio 3:4.
 * @property {string} aspect-[auto] - Class for aspect ratio auto.
 */
export const ASPECT_RATIO_CLASSES = {
  [IMAGE_ASPECT_RATIOS.RATIO_1_1]: "aspect-1/1",
  [IMAGE_ASPECT_RATIOS.RATIO_16_9]: "aspect-16/9",
  [IMAGE_ASPECT_RATIOS.RATIO_4_3]: "aspect-4/3",
  [IMAGE_ASPECT_RATIOS.RATIO_3_2]: "aspect-3/2",
  [IMAGE_ASPECT_RATIOS.RATIO_3_4]: "aspect-3/4",
  [IMAGE_ASPECT_RATIOS.RATIO_AUTO]: "aspect-[auto]"
};

/**
 * Validates aspect ratio classes.
 *
 * @param {string} aspectRatioClasses - A string of space-separated aspect ratio Tailwind classes.
 */
export function validateAspectRatioClasses(aspectRatioClasses) {
  const listOfClasses = aspectRatioClasses.split(" ");
  const validClasses = Object.values(ASPECT_RATIO_CLASSES);
  const isValid = listOfClasses.every((aspectRatioClass) => {
    return validClasses.some((validClass) => aspectRatioClass.includes(validClass));
  });

  if (!isValid) {
    console.warn("Invalid aspect ratio class detected");
  }
}
